class LoansDetailStatementIncomeController {
  constructor() {
  }
}

export default LoansDetailStatementIncomeController;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/loansDetail/loansDetailStatementIncome/loansDetailStatementIncome.controller.js